import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import PropTypes from "prop-types";
import moment from "moment";
import { Table } from "@material-ui/core";

class InvoicesTable extends Component {
  onDismissClick(id) {
    this.props.uncheckInvoice(id);
  }

  onApproveClick(id) {
    this.props.checkInvoice(id);
  }

  onViewClick(id, year) {
    this.props.viewInvoice(id, year);
  }

  render() {
    const invoices = this.props.invoices
      .sort(function(a, b) {
        return a.no - b.no;
      })
      .map(invoice => (
        <tr key={invoice.uuid}>
          <td>{invoice.year + "-" + invoice.no}</td>
          <td>{invoice.customers.company}</td>
          <td>{Number(invoice.total).toFixed(2)} $ BSD</td>
          <td>{Number(invoice.fee_total).toFixed(2)} €</td>
          <td>{invoice.vat} €</td>

          <td>
            {moment(invoice.start).format("DD.MM.") +
              " - " +
              moment(invoice.end).format("DD.MM.YYYY")}
          </td>
          <td>{moment(invoice.created_at).format("DD.MM.YYYY")}</td>
          <td>
            {invoice.status === 1 ? (
              <IconButton
                className="green-text"
                onClick={this.onDismissClick.bind(this, invoice.uuid)}
              >
                <Icon>check</Icon>
              </IconButton>
            ) : (
              <IconButton
                className="red-text"
                onClick={this.onApproveClick.bind(this, invoice.uuid)}
              >
                <Icon>close</Icon>
              </IconButton>
            )}
          </td>
          <td>
            <IconButton
              onClick={this.onViewClick.bind(this, invoice.no, invoice.year)}
            >
              <Icon>cloud_queue</Icon>
            </IconButton>
          </td>
        </tr>
      ));

    return (
      <div className="row">
        <div className="col s12 m12 l12">
          <h5 className="">Invoices</h5>
          <br />

          <br />

          <div className="card-panel">
            <Table>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Empfänger</th>
                  <th>Gesamtbetrag</th>
                  <th>Lizenz</th>
                  <th>USt.</th>
                  <th>Zeitraum</th>
                  <th>Rechnungsdatum</th>
                </tr>
              </thead>
              <tbody>{invoices}</tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

/*InvoicesTable.propTypes = {
  checkInvoice: PropTypes.func.isRequired,
  uncheckInvoice: PropTypes.func.isRequired,
  viewInvoice: PropTypes.func.isRequired
};*/

export default InvoicesTable;



// WEBPACK FOOTER //
// ./src/components/invoices/InvoiceTable.js